import { Redirect } from "react-router-dom";
import React from "react";

function Home() {
  return <Redirect to="/login" />;
}

export default Home;
